import { custom, deserialize, serializable } from "serializr";

import { DefectStatus } from "../enums/defect-status.enum";
import { DefectType } from "../enums/defect-type.enum";
import { Priority } from "../enums/prirority.enum";
import { Severity } from "../enums/Severity.enum";

import { Base } from "@/common/models/base.model";
import type { Attachment, TestSteps } from "@/common/types/generated";

/** Optional typed shape for linkitem */
export type LinkItem = {
  type?: string;
  testCaseId?: number | null;
  testStepId?: number | null;
  testCaseType?:string;
  [k: string]: any;
};

export class Defect extends Base {
  @serializable public id!: number;
  @serializable public testcaseId!: number;
  @serializable public stepAction?: string;
  @serializable public testCaseName?: string;
  @serializable public assigneeName?: string;
    @serializable public reviewerName?: string;
  @serializable public reporterName?: string;
  @serializable public title!: string;
  @serializable public description?: string;
  @serializable public stepsToReproduce?: string;
  @serializable public expectedResults?: string;
  @serializable public actualResults?: string;
  @serializable public environment?: string;
  @serializable(custom(v => v, v => v)) public filenames?: string[];
  @serializable public assigneeIds?: string;
  @serializable public reviewerIds?: string;
  @serializable public defectStatus!: DefectStatus;
  @serializable public defectType!: DefectType;
  @serializable public priority?: Priority;
  @serializable public workspaceVersionId?: number;
  @serializable public severity?: Severity;
  @serializable public deleted?: boolean;
  @serializable public createdDate?: Date;
  @serializable public defectKey?: string;
  @serializable public fileurl?: string;
  @serializable(custom(v => v, v => v)) public fileUrls?: string[];
  @serializable public updatedDate?: Date;
  @serializable public testStepId?: number;
  @serializable(custom(v => v, v => v)) public testStep?: TestSteps;
  @serializable public stepscreenshoturl?: string;
  @serializable(custom(v => v, v => v)) public fileMetadata?: Attachment[];
  @serializable public reporterId?: number;
  @serializable public cycleId?: number | null;
  @serializable public createdBy?: number;
  @serializable public updatedBy?: number;
  @serializable public createdByName?: string;
  @serializable public updatedByName?: string;

@serializable(custom(
  (v) => v, 
  (v) => {
    if (v == null) return v;
    if (typeof v === "string") {
      try { return JSON.parse(v); } catch { return v; }
    }
    return v;
  }
))
public linkitem?: any;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Defect, input));
  }
}